// src/pages/Home/index.jsx
import { useState } from 'react';
import { Card, Typography, List, Avatar, Button, Modal, Form, Input, Divider } from 'antd';
import { EditOutlined, MailOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Home = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  
  const savedUser = localStorage.getItem('user');
  const user = savedUser ? JSON.parse(savedUser) : { name: '访客' };

  const myData = [
    { title: '我的文章', count: 5 },
    { title: '我的收藏', count: 12 },
    { title: '我的评论', count: 23 },
  ];

  const showEditModal = () => {
    form.setFieldsValue(user);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = (values) => {
    const updatedUser = { ...user, ...values };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    setIsModalVisible(false);
    window.location.reload();
  };

  return (
    <div style={{ padding: 24 }}>
      <Card>
        {/* 原有的标题 */}
        <Title level={2}>我的主页</Title>
        
        {/* 原有的头像和姓名行 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          marginBottom: 24,
          position: 'relative' 
        }}>
          <Avatar size={64} style={{ backgroundColor: '#1890ff', marginRight: 16 }}>
            {user.name.charAt(0)}
          </Avatar>
          <div>
            <Title level={4} style={{ margin: 0 }}>{user.name}</Title>
            <Text type="secondary">欢迎来到个人主页</Text>
          </div>
          
          {/* 编辑按钮 */}
          <div style={{ 
            position: 'absolute', 
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)'
          }}>
            <Button 
              type="primary" 
              icon={<EditOutlined />}
              onClick={showEditModal}
            >
              编辑个人资料
            </Button>
          </div>
        </div>

        {/* 新增：保存后的个人信息显示区域 */}
        {(user.email || user.bio) && (
          <div style={{ marginBottom: 24 }}>
            <Divider />
            <Title level={4} style={{ marginBottom: 16 }}>
              <InfoCircleOutlined style={{ marginRight: 8 }} />
              个人信息
            </Title>
            
            {user.email && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <MailOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                <Text strong style={{ marginRight: 8 }}>邮箱:</Text>
                <Text>{user.email}</Text>
              </div>
            )}
            
            {user.bio && (
              <div style={{ marginTop: 12 }}>
                <Text strong style={{ marginRight: 8 }}>个人简介:</Text>
                <Text>{user.bio}</Text>
              </div>
            )}
            <Divider />
          </div>
        )}

        {/* 原有的列表 */}
        <List
          dataSource={myData}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={item.title}
              />
              <Text strong>{item.count}</Text>
            </List.Item>
          )}
        />
      </Card>

      {/* 弹窗表单 */}
      <Modal
        title="编辑个人资料"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="name"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input placeholder="请输入姓名" />
          </Form.Item>

          <Form.Item
            name="email"
            label="邮箱"
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>

          <Form.Item
            name="bio"
            label="个人简介"
          >
            <Input.TextArea placeholder="请输入个人简介" rows={3} />
          </Form.Item>

          <Form.Item style={{ textAlign: 'right' }}>
            <Button onClick={handleCancel} style={{ marginRight: 8 }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Home;